import { stripHtml } from 'helpers/parsing/stripHtml';
import { FaqEntryType } from 'types/faq';

export const extractFaqEntries = (html: string | null): FaqEntryType[] => {
    if (html === null) {
        return [];
    }

    const entries: FaqEntryType[] = [];
    const matches =
        html.match(
            /<details\b[^>]*class=(?:"[^"]*\bgjs-accordion\b[^"]*"|'[^']*\bgjs-accordion\b[^']*')[^>]*>[\s\S]*?<\/details>/gi,
        ) ?? [];

    for (const accordion of matches) {
        const question = accordion.match(/<summary\b[^>]*>([\s\S]*?)<\/summary>/i)?.[1] ?? '';
        const answer = accordion.split(/<\/summary>/i)[1] ?? '';
        const name = stripHtml(question);
        const text = stripHtml(answer);

        if (name && text) {
            entries.push({
                '@type': 'Question',
                name,
                acceptedAnswer: {
                    '@type': 'Answer',
                    text,
                },
            });
        }
    }

    return entries;
};
